import { useFormContext } from "react-hook-form";
import { ErrorMessages } from "../../../../components/errorMessages/errorMessages";

export const InputNumber = ({
  label,
  name,
  required = true,
  min,
  max,
  step,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className="form-field mt-4">
      <label htmlFor={name}>{label}</label>
      <input
        type="number"
        name={name}
        {...register(name, {
          required: {
            value: required,
            message: `${label} is required`,
          },
        })}
        placeholder={label}
        min={min}
        max={max}
        step={step}
      />
      <ErrorMessages errors={errors?.[name]?.message} />
    </div>
  );
};
